import {SiteKey} from 'Common/SiteBasics';
import { TheTownieSettings } from 'Shared/frontend/themes/TheTownieSettings';
import { TheDockSettings } from 'Shared/frontend/themes/TheDockSettings';
import { TheDrummerSettings } from 'Shared/frontend/themes/TheDrummerSettings';
import { IndieIslandSettings } from 'Shared/frontend/themes/IndieIslandSettings';
import { MoshpitSettings } from 'Shared/frontend/themes/MoshpitSettings';
import { FamilySettings } from 'Shared/frontend/themes/FamilySettings';
import { NewVenue1Settings } from 'Shared/frontend/themes/NewVenue1Settings';
import { BrewLabSettings } from 'Shared/frontend/themes/BrewLabSettings';
import { ChippoSettings } from 'Shared/frontend/themes/ChippoSettings';
import { OurWebsiteSettings } from 'Shared/frontend/themes/OurWebsiteSettings';
import { DarlingNikkisSettings } from 'Shared/frontend/themes/DarlingNikkisSettings';
import { BotanyViewSettings } from 'Shared/frontend/themes/BotanyViewSettings';
import { LucillesSettings } from 'Shared/frontend/themes/LucillesSettings';
import { PablosSettings } from 'Shared/frontend/themes/PablosSettings';
import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import { Showcase1Settings } from 'Shared/frontend/themes/Showcase1Settings';
import { Showcase2Settings } from 'Shared/frontend/themes/Showcase2Settings';
import { Showcase3Settings } from 'Shared/frontend/themes/Showcase3Settings';
import { Showcase4Settings } from 'Shared/frontend/themes/Showcase4Settings';
import { VenueSettings } from 'Shared/model/venueSettings';


export class VenueSettingsFactory 
{
	createSettings(key:SiteKey,settings:VenueSettings): BaseSettings
	{
		let ret: BaseSettings;

		switch(key) {
			case 'BBBBBBBB': ret = new TheTownieSettings(settings); break;
			case 'CCCCCCCC': ret = new TheDockSettings(settings); break;
			case 'DDDDDDDD': ret = new TheDrummerSettings(settings); break;
			case 'EEEEEEEE': ret = new IndieIslandSettings(settings); break;
			case 'FFFFFFFF': ret = new MoshpitSettings(settings); break;
			case 'GGGGGGGG': ret = new FamilySettings(settings); break;
			case 'HHHHHHHH': ret = new NewVenue1Settings(settings); break;
			case 'IIIIIIII': ret = new BrewLabSettings(settings); break;
			case 'JJJJJJJJ': ret = new ChippoSettings(settings); break;
			case 'KKKKKKKK': ret = new OurWebsiteSettings(settings); break;
			case 'LLLLLLLL': ret = new DarlingNikkisSettings(settings); break;
			case 'MMMMMMMM': ret = new BotanyViewSettings(settings); break;
			case 'NNNNNNNN': ret = new LucillesSettings(settings); break;
			case 'OOOOOOOO': ret = new PablosSettings(settings); break;
			case 'SHOWCS01': ret = new Showcase1Settings(settings); break;
			case 'SHOWCS02': ret = new Showcase2Settings(settings); break;
			case 'SHOWCS03': ret = new Showcase3Settings(settings); break;
			case 'SHOWCS04': ret = new Showcase4Settings(settings); break;

			default: throw new Error(`Unknown venue. key: ${key}`);
		}

		return ret;
	}
}

